<template>
  <div class="auto-refill-status-container">
    <div class="auto-refill-status">
      <h1 :class="{ active: status }">Auto refill is {{ statusLabel }}</h1>
      <div class="controls">
        <icon-button icon="el-icon-more" size="22" v-if="!status" @click.native="$emit('manage')" />
        <el-dropdown v-else>
          <span class="el-dropdown-link">
            <i class="el-icon-more icon-button"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!--<el-dropdown-item @click="$emit('changeCard')">Change credit card</el-dropdown-item>-->
            <!--<el-dropdown-item @click="$emit('changeValue')">Change values</el-dropdown-item>-->
            <el-dropdown-item @click.native="$emit('disable')">Disable</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="refill-settings" v-if="status">
      <div class="refill-progress">
        <el-progress :width="200" :text-inside="true" :stroke-width="15" :percentage="refillPercentage" :show-text="false" color="#008fcc" type="circle"></el-progress>
        <h1>
          <span class="upper">
            {{ saldo - minimum }} <span class="currency">{{ $root.currency }}</span>
          </span>
          <span class="lower">until refill</span>
        </h1>
      </div>
      <div class="refill-footer">
        <p>
          <span>{{ minimum }} <span class="currency">{{ $root.currency }}</span></span>
          <span class="lower">
            Minimum
          </span>
        </p>
        <p>
          <span>{{ amount }} <span class="currency">{{ $root.currency }}</span></span>
          <span class="lower">
            Refill
          </span>
        </p>
      </div>
      <!--<p>Last auto refill <span>Thursday, 09 August 2018 13:15:22</span></p>-->
      <!--<el-button type="primary">Manage</el-button>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutoRefillStatus',
  props: {
    status: {
      type: Boolean,
      required: true
    },
    minimum: {
      type: Number,
      required: true
    },
    amount: {
      type: Number,
      required: true
    },
    saldo: {
      type: Number,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    refillPercentage () {
      if (this.saldo === 0) {
        return 0
      }

      let percentage = (this.saldo / (this.minimum + this.amount)) * 100
      return percentage > 100 ? 100 : percentage
    },
    statusIcon () {
      if (this.status) {
        return 'el-icon-circle-check-outline'
      }

      return 'el-icon-more'
    },
    statusLabel () {
      if (this.status) {
        return 'enabled'
      }

      return 'disabled'
    }
  }
}
</script>

<style lang="scss" scoped>
  .icon-button {
    font-size: 22px;
    color: $text-light;
  }

  .auto-refill-status-container {
    padding: 0px 0px;

    @include breakpoint (xs) {
      padding: 0px;
    }
  }

  .refill-settings {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .refill-progress {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 25px;

      p {
        text-align: center;
        margin-top: 30px;
        color: $text-light;
        font-size: 14px;
      }

      h1 {
        margin: 0;
        position: absolute;
        top: 20px;
        text-align: center;
        width: 100%;
        height: 200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        color: $text;

        .lower {
          font-size: 12px;
          color: $text-light;
        }

        .upper {
          .currency {
            font-size: 12px;
          }
        }
      }

      div {
        transform: rotate(180deg);
        flex: 4;
      }
    }

    .refill-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 45px;


      p {
        font-size: 18px;
        color: $text-light;
        margin: 0;
        display: flex;
        flex-direction: column;
        color: $main;

        span.lower {
          font-size: 12px;
          color: $text-light;
        }

        span.currency {
          font-size: 12px;
          color: $text-light;
        }
      }
    }

    button {
      margin-top: 40px;
      margin-bottom: 25px;
      width: 150px;
      align-self: center;
    }
  }

  .auto-refill-status {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include breakpoint (xs) {
      height: auto;
    }

    h1 {
      font-size: 12px;
      color: $text-light;
      margin: 0;

      &.active {
        //color: $main;
      }
    }

    .controls {
      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/saldoAndCredit/auto-refill/AutoRefillStatus.vue